import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { Router } from '@angular/router';
import { LocalStorageService } from 'src/app/local-storage.service';
import { MessageBoxService } from 'src/app/services/message-box.service';

@Component({
  selector: 'app-dbcontrol',
  templateUrl: './dbcontrol.component.html',
  styleUrls: ['./dbcontrol.component.scss']
})
export class DBControlComponent implements OnInit {
  form: UntypedFormGroup;
  formDB: UntypedFormGroup;
  public dbControlOnMobile: boolean = false;
  
  public dbAccessAllowed: boolean = false;
  public storrages = [
    {
      key: 1,
      value: 'ServiceAppDB'
    },
    {
      key: 2,
      value: 'ServiceAppDB_Doku'
    },
    {
      key: 5,
      value: 'SwissInternDB'
    },
    {
      key: 6,
      value: 'SwissTimeEntry'
    },
    {
      key: 7,
      value: 'SwissWebConfigDB'
    },
    {
      key: 8,
      value: 'SwissWebMainDB'
    }
  ]

  public isArray: boolean = true;

  constructor(
    private fb: UntypedFormBuilder,
    private localStorageService: LocalStorageService,
    private router: Router,
    private svcMessageBox: MessageBoxService,) { 

    this.form = this.fb.group({
      dbPW: ['', Validators.required],
    });

    this.formDB = this.fb.group({
      dbDatabase: ['SwissSoftDB', Validators.required],
      dbStorrage: [1, Validators.required],
      dbKey: ['zeiten', Validators.required],
      dbUniqueField: ['servicePosID'],
      dbUniqueIDValue: ['']
    });
  }

  ngOnInit(): void {
    this.dbControlOnMobile = this.router.url === "/dbcontrol-mobile"
  }

  async onSubmit(): Promise<void> {
    if (this.form.valid) {
      let value = this.form.get('dbPW')?.value;
        
      if(value === '9200') { 
        this.dbAccessAllowed = true;
      }
    }
  }

  async onDBSubmit(): Promise<void> {
    console.log("onDBSubmit()")
    if (this.formDB.valid) {
      let dbStorrageKey = this.formDB.get('dbStorrage')?.value;
      let dbStorrage = this.storrages.filter(x => x.key === dbStorrageKey)[0].value;
      let dbKeyValue = this.formDB.get('dbKey')?.value;
      let dbCheckField = this.formDB.get('dbUniqueField')?.value;
      let dbCheckFieldValue = this.formDB.get('dbUniqueIDValue')?.value;
      console.log(dbStorrageKey, dbStorrage, dbKeyValue, dbCheckField, dbCheckFieldValue);

      this.localStorageService.get(dbKeyValue, dbStorrage).then((res) => {
        console.log(res);
        if (!res) {
          this.svcMessageBox.showError("Keine Daten", "In der Indexed-DB sind keine Daten vorhanden. Speicher/DB: " + dbStorrage + "/" + dbKeyValue);
        }
        else {
          if(dbCheckField && dbCheckFieldValue) {
            let foundedItems = (res as any).filter((x: { [x: string]: any; }) => x[dbCheckField] === dbCheckFieldValue);
            if(foundedItems) {
              if(foundedItems.length === 1) {
                let index = (res as any).findIndex((x: { [x: string]: any; }) => x[dbCheckField] === dbCheckFieldValue);
                console.log("Index", index);
                (res as any).splice(index, 1);
                this.localStorageService.add(
                  dbKeyValue,
                  res,
                  dbStorrage
                );
                this.svcMessageBox.showSuccess("Erfolgreich", "Der Datensatz wurde erfolgreich gelöscht.");
              }
              else {
                this.svcMessageBox.showError("Mehrere Datensätze", "Mit den Kriterien wird kein eindeutiger Datensatz gefunden.");
              }
            }
          }
          else {
            this.svcMessageBox.showError("Kein Kriterium", "Für das Löschen von Daten werden Einschränkungen benötigt");
          }
        }
      });
    }
  }

  goBack() {
    this.router.navigate(['timeapp/settings']);
  }


}
